import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import TimeFromNow from '../../../../elements/TimeFromNow/TimeFromNow';
import LeadIcon from './lead.svg';
import styles from './LeadTitle.module.scss';

function LeadTitle(props) {
    const { className = '', lead } = props,
        i18n = useI18n();

    if (!lead) return null;

    return (
        <div className={[className, styles.LeadTitle].join(' ')}>
            <div className={styles.title}>
                <LeadIcon />
                {i18n['label.lead']}
            </div>
            <div className={styles.time}>
                {i18n['label.scanned']}: <TimeFromNow>{lead.scan_datetime_utc}</TimeFromNow>
            </div>
        </div>
    );
}

export default LeadTitle;
